import React from 'react';

import classes from './FeaturedCareerCard.module.scss';
import Link from 'next/link';

const FeaturedCareerCard = ({ career }) => {
    return (
        <Link href={`/career-path/${career?.id}/${career?.slug}`}>
            <div className={`${classes['explore-feature-content-card-wrapper']} ${classes['career']} hover-shrink`}>
                <div className='row'>
                    <div className='col-12 col-lg-7 col-xl-8 order-2 order-lg-1'>
                        <h4 className='mt-3 mt-lg-0'>
                            Featured Paths
                        </h4>
                        <h3>
                            {career?.name}
                        </h3>
                        <div
                            className={classes['description']}
                            dangerouslySetInnerHTML={{ __html: career.description }}>
                        </div>
                        <span>{career?.lecture_count} Courses</span>
                    </div>
                    <div className='col-12 col-lg-5 col-xl-4 order-1 order-lg-2'>
                        <div className={classes['image-wrapper']}
                            style={{ backgroundImage: `url(${career?.image})` }}
                        >
                        </div>
                    </div>
                </div>
            </div>
        </Link>
    );
};

export default FeaturedCareerCard;